export function getBaseAppUrl(): string {
  const url = new URL(window.location.href);
  //const segments = url.pathname.split('/');

  // Extract the first three non-empty segments: '', 'iopp', 'app'
  //const basePath = segments.slice(0, 3).join('/');

  return `${url.origin}`;
}
